"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M20.485 2.375c.129 0 .254.049.348.133l.065.07 2.995 3.898a.51.51 0 0 1 .1.25l.003.092.004.036v.155a4.002 4.002 0 0 1-2.972 3.858l-.195.047v10.19a.522.522 0 0 1-.427.513l-.093.008H3.688a.521.521 0 0 1-.513-.427l-.008-.094v-10.19A4.005 4.005 0 0 1 .005 7.21L0 7.009v-.155c0-.031.006-.056.011-.075a.524.524 0 0 1 .054-.332l.046-.07 2.995-3.803a.519.519 0 0 1 .315-.19l.094-.009h16.97Zm-2.372 8.151a3.971 3.971 0 0 1-3.119 1.495 4.008 4.008 0 0 1-2.992-1.345 3.99 3.99 0 0 1-2.996 1.345 3.977 3.977 0 0 1-3.121-1.495 3.943 3.943 0 0 1-1.428.454l-.249.02v9.583h8.459v-7.396c0-.255.184-.468.427-.513l.094-.008h5.541c.256 0 .469.185.513.428l.008.093v7.396h.542V11a3.937 3.937 0 0 1-1.679-.474Zm.095 3.182h-4.5v6.875h4.5v-6.875Zm-6.604-1.042c.255 0 .468.185.513.427l.008.094v3.958a.522.522 0 0 1-.428.513l-.093.008H5.271a.522.522 0 0 1-.513-.427l-.008-.094v-3.958a.52.52 0 0 1 .428-.512l.093-.009h6.333Zm-.52 1.041H5.792v2.918h5.292v-2.918Zm.395-6.332H6.584v2.348a2.971 2.971 0 0 0 2.421 1.257c.932 0 1.798-.433 2.359-1.17l.115-.162V7.375Zm5.938 0h-4.896v2.272a2.957 2.957 0 0 0 2.473 1.332 2.97 2.97 0 0 0 2.307-1.105l.116-.153V7.375Zm5.503 0h-4.462v2.15c.477.29 1.004.444 1.527.444 1.428 0 2.65-1.04 2.908-2.42l.027-.174Zm-17.378 0H1.08a2.976 2.976 0 0 0 2.935 2.593c.458 0 .919-.117 1.346-.34l.181-.103v-2.15Zm10.121-3.959h-3.142v2.917h4.6l-1.458-2.917Zm-8.49 0H3.768L1.471 6.333h4.243l1.459-2.917Zm13.056 0h-3.402l1.458 2.917h4.184l-2.24-2.917Zm-8.75 0H8.337L6.879 6.333h4.6V3.416Z",
    clipRule: "evenodd"
  })]
});